import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => {
  return {
    container: {
      display: 'flex',
    },
    fullWidthContainer: { display: 'flex', flexWrap: 'wrap', width: '100%' },
    containerPadding: { padding: '0px 20px' },
  };
});
